import {axiosAuth} from "../helpers/axios_requests";
import {mapActions} from "vuex";

export default {
  methods: {
    ...mapActions([
      'actionLogoutUser',
    ]),
    logoutUser() {
      axiosAuth.logout().then(() => {
        this.actionLogoutUser()
      })
    }
  }
}
